import React, { useEffect, useMemo } from 'react'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Col, Container, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import VVinalForm from './vVinalForm';
import TableContainer from '../../components/Common/TableContainer';
import { dataActions } from '../dataSlice';

const VVinalPage = () => {
  const { t } = useTranslation('translation');
  const { isFetching, categVH } = useSelector(state => state.data);

  const breadcrumbItems = [
    { title: t('vvinal'), link: "#" },
    { title: t('vvinal'), link: "#" }
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    if (categVH.length == 0) {
      dispatch(dataActions.loadData())
    }
  }, [])

  const columns = useMemo(() => [
    {
      Header: t('VALEUR À NEUF'),
      accessor: 'puissFiscaleKm',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('age'),
      accessor: 'kmMoyenAnnuelEs',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('PF'),
      accessor: 'kmMoyenAnnuelDi',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('CARBURANT'),
      accessor: (cellProps) => {
        return (
          <div>

          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('usage'),
      accessor: (cellProps) => {
        return (
          <div>

          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('compteur'),
      accessor: (cellProps) => {
        return (
          <div>

          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('ÉTAT DU VÉHICULE / ENTRETIEN'),
      accessor: (cellProps) => {
        return (
          <div>

          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('courbe de depreciation'),
      accessor: (cellProps) => {
        return (
          <div>

          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('VVADE sans correctif'),
      accessor: (cellProps) => {
        return (
          <div>

          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('action'),
      accessor: (cellProps) => {
        return (
          <React.Fragment>

          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
  ], []);

  return (
    <React.Fragment>
      {isFetching ? (
        <div id="preloader">
          <div id="status">
            <div className="spinner">
              <i className="ri-loader-line spin-icon"></i>
            </div>
          </div>
        </div>
      ) : (
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title={t('vvinal')} breadcrumbItems={breadcrumbItems} />

            <VVinalForm />
            <TableContainer
              columns={columns}
              data={[] ?? []}
              isPagination={false}
              isAddParamList={true}
              customPageSizeOptions={true}
              iscustomPageSize={false}
              isBordered={false}
              customPageSize={10}
              canDownloadtemp={true}
              isGlobalFilter={false}
              className="table-warning"

            //handleDownloadTemp={() => downloadTemp()}
            //handleUpload={uploadData}
            />
          </Container>
        </div>)}
    </React.Fragment >
  )
}

export default VVinalPage